// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"825386d9","484":"1674e029","828":"b1c6467f","842":"b2c657f6"}[chunkId] + ".chunk.js";
};